var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.getters['maintenance/get'].form.uid === '62b97ef5737a7')?_c('Oleo100Preventive'):(this.$store.getters['maintenance/get'].form.uid === '62b97ed722d02')?_c('Oleo100Curative'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }